/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { ContentEditableEvent } from 'react-contenteditable';
import { IRequestContext } from '../interfaces';
import { EditableField, FieldType } from './editable-fields/editable-field';
import { ILinksData } from './links';

export interface ILinkItemEditProps {
    requestContext: IRequestContext;

    onTextChange?(event: ContentEditableEvent): void;
}

export interface ILinkItemProps {
    link: ILinksData;
    editProps?: ILinkItemEditProps;
}

/**
 * Component class for action links
 */
export class Link extends React.Component<ILinkItemProps> {
    constructor(props: ILinkItemProps) {
        super(props);
    }

    public render = (): JSX.Element | null => {
        if (this.props.link) {
            return (
                <EditableField
                    requestContext={this.props.editProps?.requestContext}
                    type={FieldType.Link}
                    onChange={
                        this.props.editProps?.onTextChange ? this.props.editProps.onTextChange : (event: ContentEditableEvent) => null
                    }
                    fieldProps={{
                        title: this.props.link.linkText,
                        text: this.props.link.linkText,
                        key: this.props.link.key || this.props.link.linkUrl,
                        openInNewTab: this.props.link.openInNewTab,
                        className: this.props.link.className,
                        href: this.props.link.linkUrl,
                        role: this.props.link.role || 'button',
                        ariaLabel: this.props.link.ariaLabel,
                        onClick: this.props.link.onClick,
                        additionalProperties: this.props.link.additionalProperties,
                        linkTag: this.props.link.linkTag,
                        innerClassName: this.props.link.innerClassName
                    }}
                />
            );
        }
        return null;
    };
}
